export default __webpack_public_path__ + "static/media/active6.6ddf8141.svg";